// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5520":"css/app.6816","6536":"css/admin-app.6816"}[chunkId] + ".css";
};